'use client';

import type { PropsWithChildren } from 'react';
import { VpButton } from '@vtmn-play/react/headless';
import { useTranslations } from 'next-intl';
import { useSlideAnimationContext } from '@/app/components/Provider/';
import { BeardmanIntro } from '~/components/Beardman/BeardmanIntro/BeardmanIntro';
import { useProfileCompletionContext } from '../provider/ProfileCompletionProvider';

export const ProfileCompletionIntroduction = ({ children }: PropsWithChildren) => {
  const t = useTranslations('PROFILE.COMPLETION.INTRODUCTION');
  const { animateSlide } = useSlideAnimationContext();
  const { hasStarted, setHasStarted } = useProfileCompletionContext();

  if (hasStarted) {
    return <>{children}</>;
  }

  return (
    <section className="profile-completion__introduction">
      <div className="profile-completion__introduction__illustration">
        <BeardmanIntro />
      </div>
      <h2 className="vp-title-m profile-completion__introduction__title">
        {t('TITLE')}
      </h2>
      <p className="vp-body-s profile-completion__introduction__content">
        {t('CONTENT')}
      </p>
      <div className="profile-completion__introduction__action">
        <VpButton
          data-cy="goButton"
          onClick={async () => {
            return await animateSlide({
              callback: async () => {
                setHasStarted(true);
              },
            });
          }}
        >
          {t('ACTION')}
        </VpButton>
      </div>
    </section>
  );
};
